export enum NotificationType {
    REQUESTED_SIGNATURE_FROM_LIST_OWNER = "REQUESTED_SIGNATURE_FROM_LIST_OWNER",
    LIST_OWNER_SIGNED = "LIST_OWNER_SIGNED",
    REQUESTED_SIGNATURE_FROM_LIST_ADMIN = "REQUESTED_SIGNATURE_FROM_LIST_ADMIN",
    LIST_ADMIN_SIGNED = "LIST_ADMIN_SIGNED",
    REQUESTED_APPROVAL_FROM_LICENSEE = "REQUESTED_APPROVAL_FROM_LICENSEE",
    LICENSEE_APPROVED = "LICENSEE_APPROVED",
    LICENSEE_REJECTED = "LICENSEE_REJECTED"
}

export function getNotificationMessage(notification: {
    notification_type: NotificationType;
    paf_sid?: string;
    list_owner_company_name?: string;
    list_admin_company_name?: string;
}): string {
    switch (notification.notification_type) {
        case NotificationType.REQUESTED_SIGNATURE_FROM_LIST_OWNER:
            return `Signature requested from the list owner for PAF ${notification.paf_sid} (Company: ${notification.list_owner_company_name}).`;

        case NotificationType.LIST_OWNER_SIGNED:
            return `The list owner has signed the PAF ${notification.paf_sid} (Company: ${notification.list_owner_company_name}).`;

        case NotificationType.REQUESTED_SIGNATURE_FROM_LIST_ADMIN:
            return `Signature requested from the broker for PAF ${notification.paf_sid} (Company: ${notification.list_owner_company_name}).`;

        case NotificationType.LIST_ADMIN_SIGNED:
            return `The broker has signed the PAF ${notification.paf_sid} (Company: ${notification.list_owner_company_name}).`;

        case NotificationType.REQUESTED_APPROVAL_FROM_LICENSEE:
            return `Requested approval from Data Axle for PAF ${notification.paf_sid} (Company: ${notification.list_owner_company_name}).`;

        case NotificationType.LICENSEE_APPROVED:
            return `(Company: ${notification.list_owner_company_name}) PAF ${notification.paf_sid} has been approved by Data Axle.`;

        case NotificationType.LICENSEE_REJECTED:
            return `(Company: ${notification.list_owner_company_name}) PAF ${notification.paf_sid} has been rejected by Data Axle.`;

        default:
            return "You have a new notification.";

    }
}
